import React from 'react';

import { translate } from "react-i18next";
import i18n from "i18next";
import { Form, Row, Col } from 'react-bootstrap';
import '../App.css';
import {getCountries , getCountriesMap} from '../../backend/Countries';


class PublicEventLocation extends React.Component {

    constructor(props) {
        super(props);
        this.onEventInputChange = this.onEventInputChange.bind(this);

        this.state = {
            event: this.props.detailModel
        };
    }

    onEventInputChange(obj) {
        const { name: fieldName, value: fieldValue } = obj.target;

        const { event } = this.state;

        const newEvent = {
            ...event,
            [fieldName]: fieldValue
        };

        this.props.updateModel("eventLocation", newEvent);

        this.setState({
            event: newEvent
        });

    }

    render() {
        const { t } = this.props;
        let lang = i18n.language;
        let countries = getCountries(lang);
        
        const { event: {  locationName, street, zipcode, city, country, canton} } = this.state;
        return (
            <div className=" justify-content-between d-relative mt-1 greyBg p-2">
                <Row>
                    <Col lg={8} md={8}>
                        <Form.Control placeholder={t("lokal")} className="mt-2"
                            value={locationName} name="locationName"
                            onChange={this.onEventInputChange} maxLength={250}
                        />
                    </Col>
                    <Col lg={8} md={8}>
                        <Form.Control placeholder={t("strasse")}
                            value={street} name="street"
                            onChange={this.onEventInputChange} className="mt-2" maxLength={250} />
                    </Col>
                    <Col lg={4} md={4}>&nbsp;</Col>
                    <Col lg={2} xs={6}>
                        <Form.Control placeholder={t("plz")} className="mt-2"
                            value={zipcode} name="zipcode"
                            onChange={this.onEventInputChange} maxLength={10}/>
                    </Col>
                    <Col lg={4} xs={4} >
                        <Form.Control placeholder={t("ort")} className="mt-2"
                            value={city} name="city"
                            onChange={this.onEventInputChange} maxLength={50} />
                    </Col>
                    <Col lg={6} md={6}>&nbsp;</Col>
                    <Col lg={2} xs={2} >
                        <Form.Control placeholder={t("kanton")} className="mt-2"
                            value={canton} name="canton"
                            onChange={this.onEventInputChange} maxLength={50} />
                    </Col>
                    <Col lg={4} xs={4} >
                    <Form.Control as="select" name="country" value={country} onChange={this.onEventInputChange}  className="mt-2" >
                            {[...getCountriesMap(lang).keys()].map((k, i) =>
                               <option key={k} value={k}>{countries[k]}</option>
                            )
                        }
                        </Form.Control>
                    </Col>
                </Row>
            </div>
        );
    }

}

export default translate("translations")(PublicEventLocation);

